package com.parmartechnologies.core.network.rest

import io.ktor.client.HttpClient
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.DEFAULT
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

val FriendlyClient = HttpClient {
    install(ContentNegotiation) {
        json(Json {
            prettyPrint = true
            isLenient = true
            ignoreUnknownKeys = true
        })
    }
    install(HttpTimeout) {
        this.requestTimeoutMillis = 30000
        this.socketTimeoutMillis = 30000
    }
    install(Logging) {
//        logger = Logger.SIMPLE
//        level = LogLevel.NONE
        logger = Logger.DEFAULT
        level = LogLevel.NONE
    }
}
